import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const DirectSalesLanding = {
  Content: lazy(
    () =>
      import('components/direct-sales-landing/components/DirectSalesContent')
  ),

  Header: lazy(
    () => import('components/direct-sales-landing/components/DirectSalesHeader')
  )
};

export default DirectSalesLanding;
